import React from 'react';

import css from './CommentReactionGraph.module.scss';

const CommentReactionGraph = ({label, count, percentage, colors = {}}) => {
    const style = {
        color: colors.light,
        width: `${percentage}%`
    };

    const title = `${label}: ${percentage}% (${count})`;

    return <span className={css.graph} style={style} title={title}></span>;
};

export default CommentReactionGraph;
